import { Component, computed, inject, model, OnInit, ViewChild } from '@angular/core';
import { Program, SiteTopology } from '../../../../domain/cloud-topology';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';

@Component({
  selector: 'app-program-site-modal',
  templateUrl: './program-site-modal.component.html',
  standalone: false
})
export class ProgramSiteModalComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<ProgramSiteModalComponent>);
  readonly currentSite = model('');
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  readonly filteredSites = computed(() => {
    const currentSite = this.currentSite().toLowerCase();
    return currentSite
      ? this.sites.filter(site => site.name.toLowerCase().includes(currentSite))
      : this.sites.slice();
  });
  data = inject(MAT_DIALOG_DATA);
  program: Program;
  programSites: string[]; // Now storing site IDs
  sites: SiteTopology[];

  ngOnInit(): void {
    this.program = this.data.program;
    this.programSites = this.data.programSites; // Extract IDs
    this.sites = this.data.sites;
  }

  removeSite(site: string) {
    this.programSites = this.programSites.filter(s => s !== site);
  }

  siteName(siteId: string): string {
    return this.sites.find(site => site.id === siteId)?.name;
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();

    // Add our fruit
    if (value) {
      this.programSites.push(value);
    }

    // Clear the input value
    this.currentSite.set('');
  }

  selected(event: MatAutocompleteSelectedEvent) {
    this.programSites.push(event.option.value);
    this.currentSite.set('');
    event.option.deselect();
  }
}
